
<modal
  title="Showcase Collection"
  size="full"
  :open="open"
  @close="closeModal"
>
  <form @submit.stop.prevent="submit">
    <p>
      Showcasing your collection will allow others to see your collection on the Card Ladder Showcase tab. Your personal showcase will display your profile image and display name, and it will allow users to link to your profile to contact you about your cards.
    </p>

    <p>
      NOTE: None of your pricing information will be visible for others to see.
    </p>

    <image-upload
      v-model="account.photoUrl"
      name="collection-share-image"
      label="Profile Image"
      height="110"
      width="110"
    />

    <text-input
      id="showcase-displayName"
      v-model.trim="account.displayName"
      label="Display Name"
    />

    <text-input
      id="showcase-profileLink"
      v-model.trim="account.profileLink"
      type="url"
      label="Profile Link (Instagram, Facebook, Etc.)"
    />

    <text-input
      v-model.trim="collectionName"
      label="Collection Name"
      maxlength="16"
    />

    <div class="button-row">
      <btn
        type="submit"
        :loading="submitting"
        :disabled="disabled"
        loading-text="Submitting"
      >
        {{ isPublic ? 'Save Changes' : 'Save and Enable Showcase' }}
      </btn>

      <btn
        v-if="isPublic"
        kind="error"
        :loading="removing"
        loading-text="Removing"
        @click="removeFromShowcase"
      >
        Disable Showcase
      </btn>

      <icon-button v-if="isPublic" icon="link" @click="copyLink" />
    </div>
  </form>
</modal>
